import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { type AppToken, type ResponseData } from "@/types/app";
import { axiosRequest } from "@/utils/utils-axios";
import {
  type LoginDto,
  type RegisterDto,
  type ForgotPasswordDto,
  type ResetPasswordDto,
  type ConfirmEmailDto,
} from "@/types/dto";
import { type UserContent } from "@/types/content";

export const PostLoginApp = (loginInput: LoginDto) => {
  return axiosRequest({
    url: "/api/auth/login",
    method: "post",
    data: loginInput,
  }).pipe(
    map((response) => response.data as ResponseData<AppToken>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const PostRegisterApp = (registerInput: RegisterDto) => {
  return axiosRequest({
    url: "/api/auth/register",
    method: "post",
    data: registerInput,
  }).pipe(
    map((response) => response.data as ResponseData<unknown>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const GetMe = () => {
  return axiosRequest({
    url: "/api/users/me",
    method: "get",
  }).pipe(
    map((response) => response.data as ResponseData<UserContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const PostForgotPassword = (forgotPasswordInput: ForgotPasswordDto) => {
  return axiosRequest({
    url: "/api/auth/forgot-password",
    method: "post",
    data: forgotPasswordInput,
  }).pipe(
    map((response) => response.data as ResponseData<{ message: string }>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const PostResetPassword = (
  resetPasswordInput: Omit<ResetPasswordDto, "confirmPassword">
) => {
  return axiosRequest({
    url: "/api/auth/reset-password",
    method: "post",
    data: resetPasswordInput,
  }).pipe(
    map((response) => response.data as ResponseData<{ message: string }>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const PostConfirmEmail = (confirmEmailInput: ConfirmEmailDto) => {
  return axiosRequest({
    url: "/api/auth/confirm-email",
    method: "post",
    data: confirmEmailInput,
  }).pipe(
    map((response) => response.data as ResponseData<{ message: string }>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};
